import {OnlineOfferAlternative} from '../api/types/onlineOfferAlternativesTypes';
import {translateWithFallback} from './translateWithFallback';

/** "Alternative B" or "Alternative B · Plug-in hybrid". */
export const getAlternativeLabel = (
  alternative: Pick<OnlineOfferAlternative, 'letter' | 'name'>
) => {
  const label = translateWithFallback('alternatives.label', 'Alternative {letter}', {
    letter: alternative.letter,
  });

  return alternative.name ? `${label} · ${alternative.name}` : label;
};
